import React, { Component } from 'react';
import _ from 'lodash';
import { StyleSheet, css } from 'aphrodite';

class Image extends Component {
  render() {
    let images = _([this.props.filename])
      .flatten()
      .map((path) => {
        return `url(${process.env.PUBLIC_URL}/images/${path})`;
      })
      .join();
    let imageStyle = StyleSheet.create({
      image: {
        backgroundImage: images,
        backgroundSize: '100% 100%'
      }
    });

    return(
      <div className={css(this.props.extraStyles, imageStyle.image)}>
        {this.props.children}
      </div>
    );
  }
}

export default Image;



// WEBPACK FOOTER //
// ./src/Image.js